// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.open-date-picker .inline-label {
  margin: 0;
  padding: 0;
}
.open-date-picker .react-datepicker {
  border: 0.1rem solid rgba(41, 39, 39, 0.5);
  border-radius: 0;
  margin-right: 0;
  flex: none;
}
.open-date-picker .react-datepicker__header {
  background-color: transparent;
  border: none;
  border-bottom: 0.1rem solid rgba(81, 85, 84, 0.3);
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 0.3rem;
  position: relative;
  width: 90%;
  margin-left: 5%;
}
.open-date-picker .react-datepicker__navigation--previous,
.open-date-picker .react-datepicker__navigation--next {
  border: none;
}
.open-date-picker .react-datepicker__navigation--previous:after,
.open-date-picker .react-datepicker__navigation--next:after {
  position: absolute;
  top: -0.3rem;
}
.open-date-picker .react-datepicker__navigation--previous:after {
  content: "<";
  left: 0;
  text-indent: 0;
}
.open-date-picker .react-datepicker__navigation--next:after {
  content: ">";
  right: 0;
  text-indent: 0;
}
.open-date-picker .react-datepicker__current-month {
  font-weight: 500;
  font-size: 1.1rem;
}
.open-date-picker .react-datepicker__day-names {
  display: none;
}
.open-date-picker .react-datepicker__week:hover {
  background-color: #efefef;
}
.open-date-picker .react-datepicker__day {
  font-size: 0.9rem;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0.166rem;
  padding-right: 0.166rem;
  border-radius: 0;
  z-index: 1;
  position: relative;
}
.open-date-picker .react-datepicker__day:hover {
  background-color: transparent;
  color: white;
}
.open-date-picker .react-datepicker__day:hover:before {
  content: "";
  position: absolute;
  background-color: #515554;
  border-radius: 50%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 1.5em;
  width: 1.5em;
  z-index: -2;
  border-radius: 50%;
}
.open-date-picker .react-datepicker__day--highlighted {
  position: relative;
  background-color: transparent;
  color: black;
  z-index: 1;
}
.open-date-picker .react-datepicker__day--highlighted:after {
  content: "";
  position: absolute;
  background-color: #efefef;
  border-radius: 50%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 1.5em;
  width: 1.5em;
  z-index: -2;
  border-radius: 0;
  width: 100%;
  height: 100%;
}
.open-date-picker .react-datepicker__day--highlighted:hover {
  color: white;
}
.open-date-picker .react-datepicker__day--highlighted:hover:before {
  content: "";
  position: absolute;
  background-color: #515554;
  border-radius: 50%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 1.5em;
  width: 1.5em;
  z-index: -2;
  border-radius: 50%;
  z-index: -1;
}
.open-date-picker .react-datepicker__day--today {
  color: white;
  background: transparent;
  position: relative;
  font-weight: 300;
}
.open-date-picker .react-datepicker__day--today:before {
  content: "";
  position: absolute;
  background-color: #515554;
  border-radius: 50%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 1.5em;
  width: 1.5em;
  z-index: -2;
  z-index: -1;
  text-align: center;
}
.open-date-picker .react-datepicker__day--outside-month {
  color: #d6d6d6;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/DatePicker/OpenDatePicker.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAcE;EACE,SAAA;EACA,UAAA;AAXJ;AAcE;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAZJ;AAeE;EACE,6BAAA;EACA,YAAA;EACA,iDAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAbJ;AAgBE;;EAEE,YAAA;AAdJ;AAeI;;EACE,kBAAA;EACA,YAAA;AAZN;AAgBE;EACE,YAAA;EACA,OAAA;EACA,cAAA;AAdJ;AAiBE;EACE,YAAA;EACA,QAAA;EACA,cAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,iBAAA;AAhBJ;AAmBE;EACE,aAAA;AAjBJ;AAsBE;EACE,yBD/DG;AC2CP;AAyBE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAvBJ;AAwBI;EACE,6BAAA;EACA,YAAA;AAtBN;AAuBM;EAvFJ,WAAA;EACA,kBAAA;EACA,yBDMS;ECLT,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EAgFM,kBAAA;AAZR;AAiBE;EACE,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;AAfJ;AAgBI;EAnGF,WAAA;EACA,kBAAA;EACA,yBDKK;ECJL,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EA4FI,gBAAA;EACA,WAAA;EACA,YAAA;AALN;AAOI;EACE,YAAA;AALN;AAMM;EA3GJ,WAAA;EACA,kBAAA;EACA,yBDMS;ECLT,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EAoGM,kBAAA;EACA,WAAA;AAKR;AAAE;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAEJ;AADI;EAxHF,WAAA;EACA,kBAAA;EACA,yBDMS;ECLT,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EAiHI,WAAA;EACA,kBAAA;AAYN;AARE;EACE,cAAA;AAUJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n@mixin circlePsuedoElement($color) {\n  content: '';\n  position: absolute;\n  background-color: $color;\n  border-radius: 50%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 1.5em;\n  width: 1.5em;\n  z-index: -2;\n}\n\n.open-date-picker {\n  .inline-label {\n    margin: 0;\n    padding: 0;\n  }\n\n  .react-datepicker {\n    border: 0.1rem solid transparentize($textColor, 0.5);\n    border-radius: 0;\n    margin-right: 0;\n    flex: none;\n  }\n\n  .react-datepicker__header {\n    background-color: transparent;\n    border: none;\n    border-bottom: 0.1rem solid transparentize($darkGray, 0.7);\n    font-weight: 500;\n    text-transform: uppercase;\n    padding-bottom: 0.3rem;\n    position: relative; // Allows positioning prev/next buttons absolutely below\n    width: 90%;\n    margin-left: 5%;\n  }\n\n  .react-datepicker__navigation--previous,\n  .react-datepicker__navigation--next {\n    border: none;\n    &:after {\n      position: absolute;\n      top: -0.3rem;\n    }\n  }\n\n  .react-datepicker__navigation--previous:after {\n    content: '<';\n    left: 0;\n    text-indent: 0;\n  }\n\n  .react-datepicker__navigation--next:after {\n    content: '>';\n    right: 0;\n    text-indent: 0;\n  }\n\n  .react-datepicker__current-month {\n    font-weight: 500;\n    font-size: 1.1rem;\n  }\n\n  .react-datepicker__day-names {\n    display: none;\n  }\n\n  // Week styles\n\n  .react-datepicker__week:hover {\n    background-color: $gray;\n  }\n\n  // Day styles\n\n  .react-datepicker__day {\n    font-size: 0.9rem;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0.166rem;\n    padding-right: 0.166rem;\n    border-radius: 0;\n    z-index: 1;\n    position: relative;\n    &:hover {\n      background-color: transparent;\n      color: white;\n      &:before {\n        @include circlePsuedoElement($darkGray);\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .react-datepicker__day--highlighted {\n    position: relative;\n    background-color: transparent;\n    color: black;\n    z-index: 1;\n    &:after {\n      @include circlePsuedoElement($gray);\n      border-radius: 0;\n      width: 100%;\n      height: 100%;\n    }\n    &:hover {\n      color: white;\n      &:before {\n        @include circlePsuedoElement($darkGray);\n        border-radius: 50%;\n        z-index: -1;\n      }\n    }\n  }\n\n  .react-datepicker__day--today {\n    color: white;\n    background: transparent;\n    position: relative;\n    font-weight: 300;\n    &:before {\n      @include circlePsuedoElement($darkGray);\n      z-index: -1;\n      text-align: center;\n    }\n  }\n\n  .react-datepicker__day--outside-month {\n    color: darken($gray, 10%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
